import { SCREEN_FILTER_CODE } from "constants/DashboardContanst";
import {
  AUTH_STATUS_CANCEL,
  AUTH_STATUS_CANCEL_WAITING,
  AUTH_STATUS_REJECT_CANCEL,
} from "constants/FormatDataContanst";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ListInvoice from "./ListInvoice";

const ListCancel = () => {
  const [filterList, setFilterList] = useState({
    "filter[auth_status][in]": [
      AUTH_STATUS_CANCEL_WAITING,
      AUTH_STATUS_REJECT_CANCEL,
      AUTH_STATUS_CANCEL,
    ],
  });

  const Dashboard = useSelector(state => state.Dashboard);
  const { finalBuInfo } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo) {
      setFilterList({
        ...filterList,
        "filter[invoice_type]": finalBuInfo?.invoice_type,
      });
    }
  }, [finalBuInfo]);

  return (
    <React.Fragment>
      <ListInvoice
        filterList={filterList}
        screenFilterCode={SCREEN_FILTER_CODE.INVOICE_CANCEL}
        listStatusFilter={[
          AUTH_STATUS_CANCEL_WAITING,
          AUTH_STATUS_REJECT_CANCEL,
          AUTH_STATUS_CANCEL,
        ]}
        title={"DANH SÁCH HÓA ĐƠN HỦY"}
        titleManger={"HÓA ĐƠN"}
      />
    </React.Fragment>
  );
};

export default ListCancel;
